// ============================================================================
// broiler.dailys.index — the broiler daily hub, off App's boot array
// ============================================================================
// Two obligations, and they arrived from two different owners.
//
//   broiler.dailys.list            the hub's own full-history page sequence.
//                                  Presenter-owned before; only the cursor
//                                  moved. Page size (1,000), the deleted_at
//                                  filter and the date DESC / submitted_at DESC
//                                  ordering are unchanged.
//   broiler.dailys.batchDirectory  the ppp-v4 broiler batch blob, which reached
//                                  this surface as a single `batches` prop on
//                                  BroilerEntry carrying App's former-eager
//                                  boot result. Removing that hand-off is what
//                                  retires `broilerdailys` from the frozen
//                                  app_store consumer list in
//                                  tests/fixtures/former-eager-dependencies.json.
//
// The directory resource is declared by BOTH daily surfaces because
// BroilerDailysRouter reads it above the index/record branch — the same place
// the prop used to land. A resource may only name surfaces the manifest
// declares migrated, so the record page had to move in the same change; see
// broiler.dailys.detail.ts.
//
// Saved views are not an obligation here for the same reason they are not one
// on layer.dailys.index: useSavedViewsData owns that read for every surface
// that has a picker.
//
// `refreshDailys` stays a prop and is not a residual. It is App's poultry
// refresh — a WRITE into the DailysRecentContext mirror that other surfaces
// read — and the provenance derivation scores a setter as non-consuming
// precisely so a localization is not forced to tear out a legacy mirror it does
// not own. Nothing on this surface reads that mirror.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'broiler.dailys.index',
  obligations: Object.freeze([
    Object.freeze({id: 'broiler.dailys.list', owner: 'permanent'}),
    Object.freeze({id: 'broiler.dailys.batchDirectory', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
